// extracted by mini-css-extract-plugin
export default {"MobileMenu":"MobileMenu_MobileMenu__hvvKu","open":"MobileMenu_open__tpQ45","header":"MobileMenu_header__LHfG1","logo":"MobileMenu_logo__iZmmn","close":"MobileMenu_close__rS8AR"};